module.exports = __webpack_public_path__ + "static/media/adminStepOne.923dc930.png";